import { parse } from 'query-string';

export function getCurrentDateFromSearch() {
    const search = !isSSR ? window.location.search : null;

    if (!search) {
        return null;
    }

    return parse(search).now || null;
}
